/*
 * Scroll Indicator Component
 *
 * Usage: <scroll-indicator style="--scrolled: 0%;">
 *          <div data-watch-scroll>...</div> <!-- The element to watch for scroll -->
 *          <div data-scrollbar data-clip-path="clip-path-line" hidden></div> <!-- The scrollbar element -->
 *        </scroll-indicator>
 */

class ScrollIndicator extends HTMLElement {
  constructor() {
    super();
    this.watchedElement = this.querySelector('[data-watch-scroll]');
    this.scrollbar = this.querySelector('[data-scrollbar]');
    this.handleScroll = this.handleScroll.bind(this);
  }

  connectedCallback() {
    if (!this.watchedElement) {
      this.style.setProperty('--scrolled', '0%');
      this.updateVisibility();
      return;
    }

    this.watchedElement.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleScroll);
    this.handleScroll();
  }

  disconnectedCallback() {
    if (this.watchedElement) {
      this.watchedElement.removeEventListener('scroll', this.handleScroll);
    }

    window.removeEventListener('resize', this.handleScroll);
  }

  handleScroll() {
    if (!this.watchedElement) {
      this.style.setProperty('--scrolled', '0%');
      this.updateVisibility();
      return;
    }

    const totalWidth = this.watchedElement.scrollWidth;
    const visibleWidth = this.watchedElement.clientWidth;
    const reachedWidth = this.watchedElement.scrollLeft + visibleWidth;
    const percentScrolled = totalWidth > 0 ? (reachedWidth / totalWidth) * 100 : 0;

    this.style.setProperty('--scrolled', `${Math.min(100, Math.max(0, percentScrolled))}%`);
    this.updateVisibility(totalWidth, visibleWidth);
  }

  updateVisibility(totalWidth = 0, visibleWidth = 0) {
    const hasOverflow = this.watchedElement
      ? (totalWidth || this.watchedElement.scrollWidth) > (visibleWidth || this.watchedElement.clientWidth)
      : false;

    if (this.scrollbar) {
      this.scrollbar.toggleAttribute('hidden', !hasOverflow);
    }

    this.classList.toggle('is-scrollable', hasOverflow);
  }
}

customElements.define('scroll-indicator', ScrollIndicator);